module.exports = __webpack_public_path__ + "img/thresh.af7177a5.jpg";